<template>
  <v-container class="py-7">
    <v-row>
      <v-col cols="12">
        <div class="title-container">
          <div class="title-block">
            <span class="page-title">Tenants</span>
            <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbItems"></v-breadcrumbs>
          </div>
          <div class="button-group">
            <v-btn type="button" color="primary" elevation="0" to="/tenants/novo">Incluir</v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="filter-card">
          <v-card-title class="filter-card-title">Filtro</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="load()">
              <v-row>
                <v-col cols="12" sm="4">
                  <v-text-field dense label="Nome" v-model="filter.name" hide-details outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field dense label="Código" v-model="filter.code" hide-details outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field dense label="Slug" v-model="filter.slug" hide-details outlined></v-text-field>
                </v-col>
              </v-row>
              <v-btn type="submit" color="primary" dark elevation="2">Filtrar</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="table-card">
          <v-card-title class="table-card-title">Instituições</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :server-items-length="count"
              :loading="loading"
              :options.sync="options"
              :footer-props="footerOptions"
              :disable-sort="true"
              no-data-text="Nenhuma instituição foi encontrada"
              loading-text="Carregando dados..."
              class="app-table hover-table"
              @update:items-per-page="pageSizeChanged"
              @update:page="pageChanged"
            >
              <template v-slot:[`item.status`]="{ item }">
                <v-chip label small :color="item.status === 'active' ? 'success' : 'mediumGray'" text-color="white">
                  {{ item.status }}
                </v-chip>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon @click="viewItem(item)" size="large" class="me-2">mdi-pencil-outline</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import object from "@/common/util/object";

export default {
  name: "TenantList",

  data: () => ({
    breadcrumbItems: [
      { text: "Homepage", disabled: false, to: "/home", exact: true },
      { text: "Tenants", disabled: true, exact: true },
    ],
    filter: {
      name: "",
      code: "",
      slug: "",
    },
    headers: [
      { text: "Nome", value: "name" },
      { text: "Código", value: "code" },
      { text: "Slug", value: "slug" },
      { text: "Status", value: "status" },
      { text: "Ações", value: "actions", sortable: false },
    ],
    items: [],
    loading: false,
    count: 0,
    options: {
      page: 1,
      size: 10,
    },
    footerOptions: {
      itemsPerPageText: "Itens por página:",
      itemsPerPageOptions: [10, 20, 30, 40, 50],
      pageText: "{0}-{1} de {2}",
    },
  }),

  created() {
    this.load();
  },

  methods: {
    pageChanged(page) {
      this.options.page = page;
      this.load();
    },

    pageSizeChanged(size) {
      this.options.size = size;
      this.options.page = 1;
      this.load();
    },

    async load() {
      let search = Object.fromEntries(Object.entries(this.filter).filter(([_, v]) => v));
      search = !object.isEmpty(search) ? search : null;

      this.loading = true;

      try {
        const result = await axios.get("/api/v1/tenants", {
          params: {
            page: this.options.page,
            limit: this.options.size,
            search,
          },
        });

        this.items = result.data.content.data;
        this.count = result.data.content.paging.total;
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
      } finally {
        this.loading = false;
      }
    },

    viewItem(item) {
      this.$router.push(`/tenants/${item.id}`);
    },
  },
};
</script>
